import { useTranslation } from "react-i18next";
import { useRemoteI18n } from "./useRemoteI18n";
import { I18nSearchRequest } from "../services/i18nService";
import { getPf } from "../utils/conf";

export const useTranslationEx = (
  filters?: I18nSearchRequest | undefined,
  loadOnMount: boolean = true,
  override: boolean = false,
) => {
  filters = filters ?? {
    scope: "GLOBAL",
  };
  const { t } = useTranslation();
  const { loading } = useRemoteI18n(filters, loadOnMount, override);
  return {
    t2: (key?: string, options?: Record<string, any>) => {
      if (!key) return "";
      return t(hashIfTooLong(key), {
        ...options,
        defaultValue: options?.defaultValue ?? key,
      });
    },
    loading,
  };
};

export const fnv1aHash = (input: string): string => {
  const FNV_PRIME = BigInt("1099511628211"); // 0x100000001b3
  let hash = BigInt("14695981039346656037"); // 0xcbf29ce484222325

  const encoder = new TextEncoder();
  const data = encoder.encode(input);

  for (const byte of data) {
    hash ^= BigInt(byte);
    hash *= FNV_PRIME;
    hash &= BigInt("0xFFFFFFFFFFFFFFFF"); // simulate 64-bit overflow
  }

  return hash.toString(16);
};
export const hashIfTooLong = (key: string): string => {
  if (key.length <= 64) {
    return key;
  }
  return fnv1aHash(key);
};

export const usePfTranslate = () => {
  const { t } = useTranslation();
  const TAMICE_KEY = t("Tamice");
  const TRAVITY_KEY = t("Travity");
  const pfTl = (s: string) => {
    if (getPf() === "TRAVITY") {
      return s.replace(new RegExp(TAMICE_KEY, "g"), TRAVITY_KEY);
    }
    return s;
  };
  return { pfTl };
};
